export const bookingId = 'bookingId'
export const firstName = 'firstName'
export const lastName = 'lastName'
export const dateOfBirth = 'dateOfBirth'
export const gender = 'gender'
export const infantFirstName = 'infantFirstName'
export const infantLastName = 'infantLastName'
export const infantDateOfBirth = 'infantDateOfBirth'
export const infantGender = 'infantGender'
export const luggage = 'luggage'

export default [
  bookingId,
  firstName,
  lastName,
  dateOfBirth,
  gender,
  infantFirstName,
  infantLastName,
  infantDateOfBirth,
  infantGender,
  luggage,
]
